module.exports = __webpack_public_path__ + "static/media/Thumbnail_Nitika.d1b59566.png";